import { Tag } from "@jutro/ui";
import { formatPatientCardNumber } from "components/PatientDocs/tools";
import { useDoctorGetPatientCardNumberQuery } from "lib/graphql/megaSchema";

type Props = {
  patientId: string;
};

export const PatientCardNumberTag = ({ patientId }: Props) => {
  const { data } = useDoctorGetPatientCardNumberQuery({
    variables: {
      id: patientId,
    },
  });

  return (
    <div className="flex h-6 items-center">
      {data?.doctorPatient?.patientCardNumber && (
        <Tag
          text={formatPatientCardNumber(data.doctorPatient?.patientCardNumber)}
        />
      )}
    </div>
  );
};
